export const stateKeys = {
  schoolCandidateReferencesLoading: 'schoolCandidateReferencesLoading',
  schoolSelectedCandidateReferencesLoading: 'schoolSelectedCandidateReferencesLoading',
  schoolCandidateReferencesSummaries: 'schoolCandidateReferencesSummaries',
  schoolCandidateReferences: 'schoolCandidateReferences',
  selectedSchoolCandidateReferenceId: 'selectedSchoolCandidateReferenceId',
  selectedSchoolCandidateReference: 'selectedSchoolCandidateReference',
};

export const stateLoadingKeys = {
  [stateKeys.schoolCandidateReferencesLoading]: stateKeys.schoolCandidateReferencesLoading,
  [stateKeys.schoolSelectedCandidateReferencesLoading]: stateKeys.schoolSelectedCandidateReferencesLoading
};


// WEBPACK FOOTER //
// ./src/constants/school-candidate-references.js